import { http } from '../../core/services/http';

const loadVersionStatuses = (vendorId: number, vehicleTypeId: number) =>
  http.get(`vendors/${vendorId}/appVersions`, { params: { vehicleTypeId } }).then(response => response.data);

export default loadVersionStatuses;
